import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-info-dialog',
  template: `
    <div class="dialog-overlay" *ngIf="isVisible">
      <div class="dialog-box">
        <div class="dialog-header">
          <h2>{{title}}</h2>
        
        </div>
        <div class="content-wrapper">
            <div class="dialog-content">
          <div class="content" [innerHTML]="content"></div>
        </div>
        
        <div class="button-wrapper">
            <button class=btn-style (click)="onClose()">OK</button>
        </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .dialog-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1400;
    }
    .dialog-box {
      background-color: #88a1b5;
      padding: .5rem;
      border-radius: 8px;
      min-width: 700px;
      max-width: 700px;
      max-height: 80vh;
      overflow-y: auto;
    }
    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    
    }
    .dialog-header h2 {
      color: black;
      font-weight: bold;
      margin: 0;
      font-size:1rem !important;
    }
    .close-btn {
      background: none;
      border: none;
      font-size: 24px;
      cursor: pointer;
      color: black;
    }
    .dialog-content {
    //   color: white;
      background-color: white;
      padding:.5rem;
        
    }
    .content{
          border: 1px solid #b6babc;
          padding:.3rem 1.5rem;
          height:20rem;
          color:rgb(101, 101, 106);
          overflow:auto;
    }
    .content-wrapper{
        padding:.2rem;
        background:white;
        padding-bottom:2rem;
    }
    .btn-style{
        padding: 8px 20px;
        border: 1px solid #B8B8B8;
        border-radius: 4px;
        background: white;
        cursor: pointer;
        margin: auto auto;
        font-size: 14px;

        &:hover {
          background-color: #f5f5f5;
        }
    }
    .button-wrapper{
        margin-top:1rem;
        width:100%;
        display:flex ;
        justify-content:center;
    }
  `]
})
export class InfoDialogComponent {
  @Input() isVisible = false;
  @Input() title = '';
  @Input() content = '';
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
} 